var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToastInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zm1.315 9.308H9.5v1.23h.708c.446 0 .554.231.554.662v3.415c0 .431-.108.662-.554.662h-.662v1.23H14.5v-1.23h-.63c-.447 0-.555-.23-.555-.662V9.308zM11.977 6a1.32 1.32 0 00-1.339 1.338 1.32 1.32 0 001.339 1.339 1.32 1.32 0 001.338-1.339A1.32 1.32 0 0011.977 6z"
  })));
}
export default SvgToastInfo;